import useUrlState from '@ahooksjs/use-url-state'

export default function useParams(initialState = {}, push = true) {
  const [state, setState] = useUrlState(initialState, {
    navigateMode: push ? 'push' : 'replace',
  })

  return [state, setState]
}
